<template lang="pug">
  span
    button.btn.btn-default.btn-sm(type="button" @click="modalConf = true" title="ダウンロード")
      i.fa.fa-download

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    //- ダウンロード確認
    form(v-if="modalConf" @submit.prevent="")
      app-modal(v-model="modalConf" type="primary")
        template(slot="title") 確認
        h4 選択した月の操作ログをダウンロードしますか？
        p ダウンロード準備完了まで時間がかかることがあります。
        .form-horizontal
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-primary(type="submit" @click="exports") OK
          button.btn.btn-default(type="button" @click="close") キャンセル

    //- ダウンロード準備中
    app-modal(v-model="modalExecuting" type="info" :showClose="false")
      template(slot="title") ダウンロード準備中
      h4
        i.icon.fa.fa-spinner.fa-pulse
        | &nbsp;ただいま操作ログのダウンロード準備中です。
      p ダウンロード準備完了まで時間がかかることがあります。しばらくお待ちください。
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-default(@click="cancel(); close()") キャンセル

    //- 成功
    app-modal(v-model="modalSuccess" type="success")
      template(slot="title") ダウンロード準備完了
      h4 操作ログのダウンロード準備が完了しました。
      p [ダウンロード]ボタンをクリックしてファイルをダウンロードしてください。
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-primary(type="button" @click="download()")
          i.fa.fa-download
          |  ダウンロード
        button.btn.btn-default(type="button" @click="close()") 閉じる

    //- 失敗
    app-modal(v-model="modalError" type="warning")
      template(slot="title") ダウンロード準備エラー
      h4 操作ログのダウンロード準備に失敗しました。
      p エラーメッセージ: {{message}}
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-default(type="button" @click="close()") 閉じる

    //- キャンセル
    app-modal(v-model="modalCancel")
      template(slot="title") ダウンロード準備中止
      h4 操作ログのダウンロード準備を中止しました。
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-default(type="button" @click="close()") 閉じる
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import ExportSettings from '@/components/organisms/ExportSettings'

export default {
  name: 'FuncAccessLogDownload',
  components: { AppModal, AppMessages, ExportSettings },
  props: {
    checkedIds: { type: Array, required: false, default: function () { return [] } }
  },
  data: function () {
    return {
      message: '',
      modalNoItem: false,
      modalConf: false,
      modalExecuting: false,
      modalSuccess: false,
      modalError: false,
      modalCancel: false
    }
  },
  methods: {
    /**
     * エクスポート実行
     */
    exports: function () {
      this.modalConf = false
      this.modalExecuting = true

      // 本番用
      // const vm = this
      // const formData = new FormData(this.$refs.form)
      // API実行
      // BcardRepository.postExport(formData)
      //   .then(this.onExportSuccess)
      //   .catch(function (error) {
      //     vm.onExportError(vm, error)
      //   })

      // mock用
      setTimeout(() => {
        if ((+new Date()) % 2 === 0) {
          this.onExportSuccess()
        }
        else {
          const error = { response: { data: { data: { message: 'エラーメッセージさんぷるうるるる' } } } }
          this.onExportError(this, error)
        }
      }, 1000)

      // ExportSettingsのsaveCookie()を呼び出す
      // this.$refs.exportSettings.saveCookie()
    },
    onExportSuccess () {
      // エクスポート処理結果取得処理
      this.exportResult()
    },
    onExportError (vm, error) {
      // エラーメッセージを設定
      vm.message = error.response.data.data.message
      vm.modalExecuting = false
      vm.modalError = true
    },
    exportResult: function () {
      // 本番用
      // const vm = this
      //
      // // 1秒置きにエクスポート処理結果取得処理を実行する
      // const getResult = setInterval(function () {
      //   // 前回の結果取得が終わっていない場合、結果取得を行わない
      //   if (vm.isGodResult === false) {
      //     return
      //   }
      //
      //   // 結果取得フラグをオフにする
      //   vm.isGodResult = false
      //   BcardRepository.getExportResult()
      //     .then(function (response) {
      //       // 処理結果：正常
      //       if (response.data.success) {
      //         // 「処理中」以外
      //         if (response.data.status !== 'active') {
      //           // 結果取得処理を止める
      //           clearInterval(getResult)
      //         }
      //
      //         // 正常終了
      //         if (response.data.status === 'finish') {
      //           vm.modalExecuting = false
      //           vm.modalSuccess = true
      //         }
      //         // キャンセル
      //         else if (response.data.status === 'cancel') {
      //           vm.modalExecuting = false
      //           vm.modalCancel = true
      //         }
      //       }
      //       // 処理結果：失敗
      //       else {
      //         // 結果取得処理を止める
      //         clearInterval(getResult)
      //         // エクスポートエラーの出力
      //         vm.outputError(response.data.message)
      //       }
      //     })
      //     .catch(function (error) {
      //       // 結果取得処理を止める
      //       clearInterval(getResult)
      //       // エクスポートエラーの出力
      //       vm.outputError(error.response.data.data.message)
      //     })
      //     .finally(function () {
      //       // 結果取得フラグをオンにする
      //       vm.isGodResult = true
      //     })
      // }, this.app_interval.getResult)
      // this.$store.commit('setIntervals', getResult)

      // mock用
      this.modalExecuting = false
      this.modalSuccess = true
    },
    /**
     * エクスポートエラーの出力
     * @param String message エラーメッセージ
     */
    outputError: function (message) {
      // エラーメッセージを設定
      this.message = message

      this.modalExecuting = false
      this.modalError = true
    },
    download: function () {
      // 本番用
      // const vm = this
      // // ダウンロード中ではない場合のみ実行する
      // if (this.isDownloading === false) {
      //   this.isDownloading = true
      //
      //   // ダウンロード処理を行う
      //   this.getFileDL('noimage', 'getExport', 'noimage_export.csv')
      //     .catch(function (error) {
      //       vm.setErrorMessage(error)
      //     })
      //     .finally(function () {
      //       vm.isDownloading = false
      //     })
      // }
    },
    cancel: function () {
      // 本番用
      // const vm = this
      // // エクスポートキャンセル処理を実行
      // BcardRepository.cancelExport()
      //   .catch(function (error) {
      //     vm.setErrorMessage(error)
      //   })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/accesslog/_FuncAccessLogDownload.vue